<template>
	<div class="form-row">
		<div class="form-group col-md-12">
			<label for="checkout-email">Purchase Order#</label>
			<input type="text" class="form-control" id="enter-po" :class="invalidPO.className" placeholder="Enter your P.O. number" v-model="purchaseorder" >
			<div class="invalid-feedback">{{invalidPO.message}}</div>
		</div>
	</div>
	<div class="block-space--layout--divider-15"></div>
    <div class="checkout__payment-methods payment-methods">
		<ul class="payment-methods__list">
			<li class="payment-methods__item">
				<label class="payment-methods__item-header">
					<span class="payment-methods__item-radio ">
						<span class="input-radio__body">
							<input class="" name="checkout_payment_method" type="checkbox" value="CC" v-model="hasCC" >
							<!-- <span class="input-radio__circle"></span> -->
						</span>
					</span>
					<span class="payment-methods__item-title">Credit Card</span>
				</label>
                <div class="payment-methods__item-container"  :class="(hasCC) ? 'payment-methods__item--active' : ''">
                    <div class="checkout__payment-methods checkout__payment-methods-cc-accordian">

						<div class="form-group">														
							<label for="checkout-business-state">Saved Cards on File</label>
							<select id="saved-cc" name="saved-cc" v-model="cc_saved_id" class="form-control" @change="selectCCSaved">
								<option v-for="cc in saved_cc"
								:key="cc" :value="cc.PPISCCN">
									{{cc.ADNAME}} *****{{cc.PPIL4}}
								</option>
								<option value="">**New**</option>
							</select>
						</div>	
						<div class="block-space--layout--divider-order-entry"></div>
						<div class="vehicle-form__divider" v-if="cc_saved_id == ''">Add a New Card</div>	
						
						<div class="form-row" v-if="cc_saved_id == '' && hasToken == true">
							<!-- <label for="checkout-first-name">Name on Card</label>
							<input type="text" class="form-control" id="checkout-first-name" placeholder="" @change="updCCDetails" v-model="cc_name"> -->
							<div class="form-group col-md-6">
								<label for="checkout-shipping-first-name">First Name</label><label class="required-field" >*</label>
								<input type="text" class="form-control" :class="invalidCC_Name.className" id="checkout-shipping-first-name" placeholder="" v-model="cc_fname" @change="updCCDetails">
								<div class="invalid-feedback">{{invalidCC_Name.message}}</div>
							</div>
							<div class="form-group col-md-6">
								<label for="checkout-shipping-last-name">Last Name</label><label class="required-field" >*</label>
								<input type="text" class="form-control" id="checkout-shipping-last-name" placeholder="" v-model="cc_lname" @change="updCCDetails">
							</div>
						</div>

						<div class="form-group" v-if="cc_saved_id == ''">
							<label for="checkout-street-address">Card Number</label><label class="required-field" >*</label>
							<!-- <input type="text" class="form-control" id="ccnum" name="cardnumber" placeholder=""> -->
							<iframe v-if="hasToken" :src="cc_src" scrolling="no" frameborder="0"></iframe>
							<div v-else>
								<h6 class="cc_error_msg">CREDIT CARD PAYMENT IS NOT AVAILABLE</h6>
							</div>
							<input type="hidden" name="cctoken" id="cctoken" />
							
						</div>

						<div class="form-row" v-if="cc_saved_id == '' && hasToken == true">
							<div class="form-group col-md-4">                                           
								<label for="expiration-month">Expiration Mo</label><label class="required-field" >*</label>
								<select id="expiration-month" :class="invalidCC_MO.className" class="form-control form-control-select2" v-model="cc_exp_mo" @change="updCCDetails">
									<option value="">Select </option>
									<option value="01">January</option>
									<option value="02">February</option>
									<option value="03">March</option>
									<option value="04">April</option>
									<option value="05">May</option>
									<option value="06">June</option>
									<option value="07">July</option>
									<option value="08">August</option>
									<option value="09">September</option>
									<option value="10">October</option>
									<option value="11">November</option>
									<option value="12">December</option>
								</select>
								<div class="invalid-feedback">{{invalidCC_MO.message}}</div>
							</div>
							<div class="form-group col-md-4">                                           
								<label for="expiration-year">Expiration Year</label><label class="required-field" >*</label>
								<select id="expiration-year" :class="invalidCC_Yr.className" class="form-control form-control-select2" v-model="cc_exp_yr" @change="updCCDetails">
									<option value="Select">Select </option>
									<option value="2021">2021 </option>
									<option value="2022">2022</option>
									<option value="2023">2023</option>
									<option value="2024">2024</option>
									<option value="2025">2025</option>
									<option value="2026">2026</option>
									<option value="2027">2027</option>
								</select>
								<div class="invalid-feedback">{{invalidCC_Yr.message}}</div>
							</div>
							<div class="form-group col-md-4">
								<label for="checkout-last-name">CVV</label><label class="required-field" >*</label>
								<input type="text" class="form-control" :class="invalidCC_CVV.className" id="checkout-last-name" placeholder="" v-model="cc_cvv" @change="updCCDetails">
								<div class="invalid-feedback">{{invalidCC_CVV.message}}</div>
							</div>
						</div>

						<div class="form-row" v-if="cc_saved_id == '' && hasToken == true">
                            <div class="form-group col-md-6">
                                <div class="form-group">
                                    <label for="checkout-postcode">ZIP / Postal Code</label><label class="required-field" >*</label>
                                    <input type="text" class="form-control" :class="invalidCC_Zip.className" id="checkout-postcode" v-model="cc_zip" @change="updCCDetails">
									<div class="invalid-feedback">{{invalidCC_Zip.message}}</div>
                                </div>
                            </div>
                        </div>

						<div class="form-row" v-if="cc_saved_id == '' && hasToken == true">
							<div class="form-group col-md-12">
								<div class="form-group">
									<label for="checkout-business-state">Country</label><label class="required-field">*</label>
									<select id="country" name="country" class="form-control form-control-select2" v-model="cc_country" :class="invalidCC_Country.className">
										<option value="United States of America">United States of America</option>
										<option value="Canada">Canada</option>
										<option value="Afganistan">Afghanistan</option>
										<option value="Albania">Albania</option>
										<option value="Algeria">Algeria</option>
										<option value="American Samoa">American Samoa</option>
										<option value="Andorra">Andorra</option>
										<option value="Angola">Angola</option>
										<option value="Anguilla">Anguilla</option>
										<option value="Antigua & Barbuda">Antigua & Barbuda</option>
										<option value="Argentina">Argentina</option>
										<option value="Armenia">Armenia</option>
										<option value="Aruba">Aruba</option>
										<option value="Australia">Australia</option>
										<option value="Austria">Austria</option>
										<option value="Azerbaijan">Azerbaijan</option>
										<option value="Bahamas">Bahamas</option>
										<option value="Bahrain">Bahrain</option>
										<option value="Bangladesh">Bangladesh</option>
										<option value="Barbados">Barbados</option>
										<option value="Belarus">Belarus</option>
										<option value="Belgium">Belgium</option>
										<option value="Belize">Belize</option>
										<option value="Benin">Benin</option>
										<option value="Bermuda">Bermuda</option>
										<option value="Bhutan">Bhutan</option>
										<option value="Bolivia">Bolivia</option>
										<option value="Bonaire">Bonaire</option>
										<option value="Bosnia & Herzegovina">Bosnia & Herzegovina</option>
										<option value="Botswana">Botswana</option>
										<option value="Brazil">Brazil</option>
										<option value="British Indian Ocean Ter">British Indian Ocean Ter</option>
										<option value="Brunei">Brunei</option>
										<option value="Bulgaria">Bulgaria</option>
										<option value="Burkina Faso">Burkina Faso</option>
										<option value="Burundi">Burundi</option>
										<option value="Cambodia">Cambodia</option>
										<option value="Cameroon">Cameroon</option>
										<option value="Canary Islands">Canary Islands</option>
										<option value="Cape Verde">Cape Verde</option>
										<option value="Cayman Islands">Cayman Islands</option>
										<option value="Central African Republic">Central African Republic</option>
										<option value="Chad">Chad</option>
										<option value="Channel Islands">Channel Islands</option>
										<option value="Chile">Chile</option>
										<option value="China">China</option>
										<option value="Christmas Island">Christmas Island</option>
										<option value="Cocos Island">Cocos Island</option>
										<option value="Colombia">Colombia</option>
										<option value="Comoros">Comoros</option>
										<option value="Congo">Congo</option>
										<option value="Cook Islands">Cook Islands</option>
										<option value="Costa Rica">Costa Rica</option>
										<option value="Cote DIvoire">Cote DIvoire</option>
										<option value="Croatia">Croatia</option>
										<option value="Cuba">Cuba</option>
										<option value="Curaco">Curacao</option>
										<option value="Cyprus">Cyprus</option>
										<option value="Czech Republic">Czech Republic</option>
										<option value="Denmark">Denmark</option>
										<option value="Djibouti">Djibouti</option>
										<option value="Dominica">Dominica</option>
										<option value="Dominican Republic">Dominican Republic</option>
										<option value="East Timor">East Timor</option>
										<option value="Ecuador">Ecuador</option>
										<option value="Egypt">Egypt</option>
										<option value="El Salvador">El Salvador</option>
										<option value="Equatorial Guinea">Equatorial Guinea</option>
										<option value="Eritrea">Eritrea</option>
										<option value="Estonia">Estonia</option>
										<option value="Ethiopia">Ethiopia</option>
										<option value="Falkland Islands">Falkland Islands</option>
										<option value="Faroe Islands">Faroe Islands</option>
										<option value="Fiji">Fiji</option>
										<option value="Finland">Finland</option>
										<option value="France">France</option>
										<option value="French Guiana">French Guiana</option>
										<option value="French Polynesia">French Polynesia</option>
										<option value="French Southern Ter">French Southern Ter</option>
										<option value="Gabon">Gabon</option>
										<option value="Gambia">Gambia</option>
										<option value="Georgia">Georgia</option>
										<option value="Germany">Germany</option>
										<option value="Ghana">Ghana</option>
										<option value="Gibraltar">Gibraltar</option>
										<option value="Great Britain">Great Britain</option>
										<option value="Greece">Greece</option>
										<option value="Greenland">Greenland</option>
										<option value="Grenada">Grenada</option>
										<option value="Guadeloupe">Guadeloupe</option>
										<option value="Guam">Guam</option>
										<option value="Guatemala">Guatemala</option>
										<option value="Guinea">Guinea</option>
										<option value="Guyana">Guyana</option>
										<option value="Haiti">Haiti</option>
										<option value="Hawaii">Hawaii</option>
										<option value="Honduras">Honduras</option>
										<option value="Hong Kong">Hong Kong</option>
										<option value="Hungary">Hungary</option>
										<option value="Iceland">Iceland</option>
										<option value="Indonesia">Indonesia</option>
										<option value="India">India</option>
										<option value="Iran">Iran</option>
										<option value="Iraq">Iraq</option>
										<option value="Ireland">Ireland</option>
										<option value="Isle of Man">Isle of Man</option>
										<option value="Israel">Israel</option>
										<option value="Italy">Italy</option>
										<option value="Jamaica">Jamaica</option>
										<option value="Japan">Japan</option>
										<option value="Jordan">Jordan</option>
										<option value="Kazakhstan">Kazakhstan</option>
										<option value="Kenya">Kenya</option>
										<option value="Kiribati">Kiribati</option>
										<option value="Korea North">Korea North</option>
										<option value="Korea Sout">Korea South</option>
										<option value="Kuwait">Kuwait</option>
										<option value="Kyrgyzstan">Kyrgyzstan</option>
										<option value="Laos">Laos</option>
										<option value="Latvia">Latvia</option>
										<option value="Lebanon">Lebanon</option>
										<option value="Lesotho">Lesotho</option>
										<option value="Liberia">Liberia</option>
										<option value="Libya">Libya</option>
										<option value="Liechtenstein">Liechtenstein</option>
										<option value="Lithuania">Lithuania</option>
										<option value="Luxembourg">Luxembourg</option>
										<option value="Macau">Macau</option>
										<option value="Macedonia">Macedonia</option>
										<option value="Madagascar">Madagascar</option>
										<option value="Malaysia">Malaysia</option>
										<option value="Malawi">Malawi</option>
										<option value="Maldives">Maldives</option>
										<option value="Mali">Mali</option>
										<option value="Malta">Malta</option>
										<option value="Marshall Islands">Marshall Islands</option>
										<option value="Martinique">Martinique</option>
										<option value="Mauritania">Mauritania</option>
										<option value="Mauritius">Mauritius</option>
										<option value="Mayotte">Mayotte</option>
										<option value="Mexico">Mexico</option>
										<option value="Midway Islands">Midway Islands</option>
										<option value="Moldova">Moldova</option>
										<option value="Monaco">Monaco</option>
										<option value="Mongolia">Mongolia</option>
										<option value="Montserrat">Montserrat</option>
										<option value="Morocco">Morocco</option>
										<option value="Mozambique">Mozambique</option>
										<option value="Myanmar">Myanmar</option>
										<option value="Nambia">Nambia</option>
										<option value="Nauru">Nauru</option>
										<option value="Nepal">Nepal</option>
										<option value="Netherland Antilles">Netherland Antilles</option>
										<option value="Netherlands">Netherlands (Holland, Europe)</option>
										<option value="Nevis">Nevis</option>
										<option value="New Caledonia">New Caledonia</option>
										<option value="New Zealand">New Zealand</option>
										<option value="Nicaragua">Nicaragua</option>
										<option value="Niger">Niger</option>
										<option value="Nigeria">Nigeria</option>
										<option value="Niue">Niue</option>
										<option value="Norfolk Island">Norfolk Island</option>
										<option value="Norway">Norway</option>
										<option value="Oman">Oman</option>
										<option value="Pakistan">Pakistan</option>
										<option value="Palau Island">Palau Island</option>
										<option value="Palestine">Palestine</option>
										<option value="Panama">Panama</option>
										<option value="Papua New Guinea">Papua New Guinea</option>
										<option value="Paraguay">Paraguay</option>
										<option value="Peru">Peru</option>
										<option value="Phillipines">Philippines</option>
										<option value="Pitcairn Island">Pitcairn Island</option>
										<option value="Poland">Poland</option>
										<option value="Portugal">Portugal</option>
										<option value="Puerto Rico">Puerto Rico</option>
										<option value="Qatar">Qatar</option>
										<option value="Republic of Montenegro">Republic of Montenegro</option>
										<option value="Republic of Serbia">Republic of Serbia</option>
										<option value="Reunion">Reunion</option>
										<option value="Romania">Romania</option>
										<option value="Russia">Russia</option>
										<option value="Rwanda">Rwanda</option>
										<option value="St Barthelemy">St Barthelemy</option>
										<option value="St Eustatius">St Eustatius</option>
										<option value="St Helena">St Helena</option>
										<option value="St Kitts-Nevis">St Kitts-Nevis</option>
										<option value="St Lucia">St Lucia</option>
										<option value="St Maarten">St Maarten</option>
										<option value="St Pierre & Miquelon">St Pierre & Miquelon</option>
										<option value="St Vincent & Grenadines">St Vincent & Grenadines</option>
										<option value="Saipan">Saipan</option>
										<option value="Samoa">Samoa</option>
										<option value="Samoa American">Samoa American</option>
										<option value="San Marino">San Marino</option>
										<option value="Sao Tome & Principe">Sao Tome & Principe</option>
										<option value="Saudi Arabia">Saudi Arabia</option>
										<option value="Senegal">Senegal</option>
										<option value="Seychelles">Seychelles</option>
										<option value="Sierra Leone">Sierra Leone</option>
										<option value="Singapore">Singapore</option>
										<option value="Slovakia">Slovakia</option>
										<option value="Slovenia">Slovenia</option>
										<option value="Solomon Islands">Solomon Islands</option>
										<option value="Somalia">Somalia</option>
										<option value="South Africa">South Africa</option>
										<option value="Spain">Spain</option>
										<option value="Sri Lanka">Sri Lanka</option>
										<option value="Sudan">Sudan</option>
										<option value="Suriname">Suriname</option>
										<option value="Swaziland">Swaziland</option>
										<option value="Sweden">Sweden</option>
										<option value="Switzerland">Switzerland</option>
										<option value="Syria">Syria</option>
										<option value="Tahiti">Tahiti</option>
										<option value="Taiwan">Taiwan</option>
										<option value="Tajikistan">Tajikistan</option>
										<option value="Tanzania">Tanzania</option>
										<option value="Thailand">Thailand</option>
										<option value="Togo">Togo</option>
										<option value="Tokelau">Tokelau</option>
										<option value="Tonga">Tonga</option>
										<option value="Trinidad & Tobago">Trinidad & Tobago</option>
										<option value="Tunisia">Tunisia</option>
										<option value="Turkey">Turkey</option>
										<option value="Turkmenistan">Turkmenistan</option>
										<option value="Turks & Caicos Is">Turks & Caicos Is</option>
										<option value="Tuvalu">Tuvalu</option>
										<option value="Uganda">Uganda</option>
										<option value="United Kingdom">United Kingdom</option>
										<option value="Ukraine">Ukraine</option>
										<option value="United Arab Erimates">United Arab Emirates</option>
										<option value="Uraguay">Uruguay</option>
										<option value="Uzbekistan">Uzbekistan</option>
										<option value="Vanuatu">Vanuatu</option>
										<option value="Vatican City State">Vatican City State</option>
										<option value="Venezuela">Venezuela</option>
										<option value="Vietnam">Vietnam</option>
										<option value="Virgin Islands (Brit)">Virgin Islands (Brit)</option>
										<option value="Virgin Islands (USA)">Virgin Islands (USA)</option>
										<option value="Wake Island">Wake Island</option>
										<option value="Wallis & Futana Is">Wallis & Futana Is</option>
										<option value="Yemen">Yemen</option>
										<option value="Zaire">Zaire</option>
										<option value="Zambia">Zambia</option>
										<option value="Zimbabwe">Zimbabwe</option>
									</select>
									<div class="invalid-feedback">{{invalidCC_Country.message}}</div>
								</div>
							</div>
							<div class="block-space--layout--divider-xs"></div>
							<div class="form-group form-group-cc-save">		
								<div class="form-check">
									<span class="input-check form-check-input">
										<span class="input-check__body">
											<input class="input-check__input" type="checkbox" id="save-creditcard" @change="cc_save" v-model="checkCCSave" value='Y'>
											<span class="input-check__box"></span>
											<span class="input-check__icon"><svg width="9px" height="7px">
													<path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
												</svg>
											</span>
										</span>
									</span>
									
									<label class="form-check-label" for="save-creditcard">
										Save encrypted credit card details to my account
									</label>
								</div>		
							</div>	
						</div>

					</div>
                </div>
			</li>                           
		</ul>
	</div>

	<base-dialog title="WE ARE UNABLE TO PROCESS YOUR PAYMENT" @close="showAlert = false" :open="showAlert === true">
		<template #default>
			<p>We are unable to process credit card payments for orders containing items from more than one location. Please use a Purchase Order to process your order.</p>
		</template>
		<template #actions>
			<button type="button" class="btn btn-sm btn-primary" @click="showAlert = false">
				Ok
			</button>
		</template>
	</base-dialog>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';
import ErrorFields from '../../../mixins/ErrorFields.js';

export default {
	mixins: [ErrorFields],
	data() {
		return {
			paymenttype: '',
			purchaseorder: '',
			cc_src: null,
			checkCCSave: false,
			active_method:'',
			showAlert : false,
			hasCC: false,
			hasToken: true,

			cc_fname: null,
			cc_lname: null,
            cc_cvv: null,
            cc_exp_mo: null,
            cc_exp_yr: null,
            cc_address: null,
            cc_state: null,
            cc_city: null,
            cc_zip: null,
			cc_saved_id: '',
			cc_country: 'United States of America',

			cc_token: null,

			saved_cc: [],
			uniques: [],
		}
	},
	computed: {
		...mapGetters([
            'getDefaultLocationDetails',
			'errorFields',
			'customerDefaultCC'
        ]),
		...mapGetters("cart", [
            "cart",
        ]),

		uniqueLength() {
            let uniques = [... new Set(this.cart.map((item) => 
                item.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : item.locationid
            ))];

            return uniques.length;
        },
	},
	methods: {
        updateOrderDetails() {
            this.$store.dispatch('cart/orderdetails', {
                "paymenttype": this.paymenttype,
                "purchaseorder": this.purchaseorder
            });
        },

		getCCInput() {
			const iframecss = "input:focus{box-shadow: none; background-color: rgb(255, 255, 255); border-color: border-color:rgb(217, 217, 217);}input:hover{border-color:rgb(217, 217, 217);}input{width:371px;height:34px;border-radius:2px;background-color:rgb(235, 235, 235);color:rgb(38, 38, 38);margin-top: -7px;margin-left: -7px;}";
            const cc_input = this.$store.getters['api/cc_input_uri'];
            axiosvl.post(cc_input, {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                let messages = [];
				
				if(fields.TOKENIZER.value != ''){
					this.hasToken = true;
					this.cc_src = fields.TOKENIZER.value + '?css=' + encodeURI(iframecss);
				}else{
					this.hasToken = false;
				}

                this.isloading = false;
                this.servermessages = messages;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

		updCCDetails() {
			this.$store.dispatch('cart/cc_details', {
				"cc_token": this.cc_token,
				"cc_fname": this.cc_fname,
				"cc_lname": this.cc_lname,
				"cc_cvv": this.cc_cvv,
				"cc_exp_mo": this.cc_exp_mo,
				"cc_exp_yr": this.cc_exp_yr,
				"cc_address": this.cc_address,
				"cc_state": this.cc_state,
				"cc_zip": this.cc_zip,
				"cc_country": this.cc_country
			});
		},

		selectCCSaved() {
			// console.log(this.cc_saved_id);
			this.$store.dispatch('cart/cc_saved_id', { 'cc_saved_id' : this.cc_saved_id });
		},
		
		// on receive message on change of enter credit card input
		message : function(e) {

			try {  
				const token = JSON.parse(e.data);  
				this.cc_token = token.message;
				// this.cc_token = '9488604401518189';
				this.updCCDetails();

			} catch (e) {  
				// console.log('invalid json');  
			}
		},

		getSavedCC() {

			axiosvl.post(this.$store.getters['api/get_saved_cc_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
				const results = [];
				
				for (const key in response.data.webroutine.lists.SCCS.entries) {
					const obj = response.data.webroutine.lists.SCCS.entries[key];
					results.push({
						ADADRC: obj.ADADRC,
						ADCODE: obj.ADCODE,
						ADIPHNUM: obj.ADIPHNUM,
						ADNAME: obj.ADNAME,
						ADTYPE: obj.ADTYPE,
						PPIL4: obj.PPIL4,
						PPISCCN: obj.PPISCCN,
						PPITNT: obj.PPITNT,
						SCCSL: obj.SCCSL,
					});

					if(key == 0){
						this.cc_saved_id = obj.PPISCCN;
						this.selectCCSaved();
					}
				}
                // console.log(this.customerDefaultCC);

				this.saved_cc = results;

				if(this.customerDefaultCC.savednumber != ''){
					// get the default cc saved from Payment Methods
					this.cc_saved_id = this.customerDefaultCC.savednumber;
					// store cc_saved_id  to be use for payment
					this.selectCCSaved();
				}


				// console.log(this.saved_cc);
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
		},

		cc_save() {
            if (this.checkCCSave){
                this.CCSAVE = 'Y';
            }else{
                this.CCSAVE = 'N';
            }
			// update the to_save_new_cc state
			this.$store.dispatch('cart/to_save_new_cc', { 'to_save_new_cc' : this.CCSAVE });
        },

		uniqueLocations() {
            this.uniques = [... new Set(this.cart.map((item) => 
                item.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : item.locationid
            ))];

            this.uniques.sort((a,b) => (a > b) ? 1 : ((b > a) ? -1 : 0));
        },
	},

	watch: {
		// whenever paymenttype changes, this function will run
		paymenttype(paymenttype) {
			console.log('paymenttype = ' + paymenttype);
			if(paymenttype == 'CC') {
				let uniques = [... new Set(this.cart.map((item) => 
					item.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : item.locationid
				))];
				if(uniques.length > 1){
					// show alert error message
					this.showAlert = true;
					this.paymenttype = '';
				}else{
					this.updCCDetails();
					this.getSavedCC();
				}
			}
		},

		hasCC(newVal) {
			if(newVal == true){
				this.updCCDetails();
				this.getSavedCC();
				this.paymenttype = 'CC';
			}else{
				this.paymenttype = '';
			}
		}
    },

	updated() {
		this.updateOrderDetails();
		// console.log(this.errorFields);

		// update the checkbox for CC
		// based on the error message from Checkout B2B
		let invalid = this.errorFields.find((item) => {
			return (item.input === 'CC_Check')
		});
		
		if(invalid != undefined){
			this.hasCC = true;
		}
	},
	created() {
		this.getCCInput();
		this.paymenttype = '', this.purchaseorder = '';
		this.cc_saved_id = '';
		this.uniqueLocations();

		window.addEventListener('message', this.message);

		this.$store.dispatch('cart/cc_saved_id', { 'cc_saved_id' : this.cc_saved_id });

		this.$store.dispatch('setErrorFields', []);
	},

	unmounted: function() {
		window.removeEventListener('message', this.message);
	}
}
</script>

<style scoped>
	iframe {
		width: 380px;
		height: 41px;
	}

	.payment-methods__item--active{
		height: auto;
		opacity: 100;
	}

	.cc_error_msg {
		border: 1px solid red;
		padding: 5px;
	}
</style>